import React from "react";
import {observer} from "mobx-react-lite";
import {Avatar, Chip} from "@mui/material";
import {useStores} from "~/stores";
import {AuthorChip} from "~/pages/taxonomy-editor/approval/component/AuthorChip";
import type {EditAuthor} from "~/prototypes/pages/taxonomy-canvas/taxonomyEdits.ts";

/**
 * The author of a change: the app's AuthorChip when that user is in the loaded user list (same look as the
 * taxonomy approval page), otherwise a plain chip with the name recorded at edit time.
 */
export const EditAuthorChip: React.FC<{author: EditAuthor}> = observer(({author}) => {
    const {authStore} = useStores();
    if (author.id !== undefined && authStore.allUsers.has(author.id)) return <AuthorChip authorId={author.id}/>;
    const initials = author.name.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
    return <Chip
        avatar={<Avatar>{initials || '?'}</Avatar>}
        label={author.name}
        variant="outlined"
        size="small"
    />;
});
